<div class="grid grid-cols-2 h-full">
	<div class="bg-gray-50 flex items-center justify-center">
		<img
			class="max-w-sm"
			src="assets/images/undraw/undraw_celebration_wtm8.svg"
			alt="Closer's Email Integration"
		/>
	</div>
	<div class="px-8 py-6">
		<h3 class="h3 mb-6">You’re All Set</h3>
		<p class="p mb-6">
			All your emails from closer will be sent from {{ email_() }}
		</p>
		<p class="p">Start exploring our templates now!</p>
	</div>
</div>
